
export default function ServiceIntro() {
  return (
    <section className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-extrabold text-gray-900 mb-6">
            Tại Sao Chọn Chúng Tôi?
          </h2>
          <p className="text-xl md:text-2xl text-gray-800 max-w-3xl mx-auto font-semibold">
            Đối tác tin cậy của các công ty du lịch, phòng vé và tổ chức đoàn Việt Nam tại Hoa Kỳ
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {/* Feature 1 */}
          <div className="bg-gradient-to-br from-blue-50 to-white rounded-2xl p-8 shadow-lg hover:shadow-xl transition-all duration-300 border border-blue-100">
            <div className="w-16 h-16 bg-blue-900 rounded-full flex items-center justify-center mb-6">
              <i className="ri-car-line text-white text-3xl"></i>
            </div>
            <h3 className="text-2xl font-extrabold text-gray-900 mb-4">
              Đa Dạng Loại Xe
            </h3>
            <p className="text-lg text-gray-800 leading-relaxed font-semibold">
              Từ xe 7 chỗ cao cấp đến xe bus 56 chỗ, đáp ứng mọi quy mô đoàn từ gia đình đến đoàn lớn.
            </p>
          </div>

          {/* Feature 2 */}
          <div className="bg-gradient-to-br from-red-50 to-white rounded-2xl p-8 shadow-lg hover:shadow-xl transition-all duration-300 border border-red-100">
            <div className="w-16 h-16 bg-red-600 rounded-full flex items-center justify-center mb-6">
              <i className="ri-user-star-line text-white text-3xl"></i>
            </div>
            <h3 className="text-2xl font-extrabold text-gray-900 mb-4">
              Lái Xe Chuyên Nghiệp
            </h3>
            <p className="text-lg text-gray-800 leading-relaxed font-semibold">
              Đội ngũ lái xe tiếng Việt &amp; tiếng Anh, am hiểu văn hóa, nhiệt tình và có kinh nghiệm lâu năm.
            </p>
          </div>

          {/* Feature 3 */}
          <div className="bg-gradient-to-br from-green-50 to-white rounded-2xl p-8 shadow-lg hover:shadow-xl transition-all duration-300 border border-green-100">
            <div className="w-16 h-16 bg-green-600 rounded-full flex items-center justify-center mb-6">
              <i className="ri-price-tag-3-line text-white text-3xl"></i>
            </div>
            <h3 className="text-2xl font-extrabold text-gray-900 mb-4">
              Giá Cả Linh Hoạt
            </h3>
            <p className="text-lg text-gray-800 leading-relaxed font-semibold">
              Báo giá minh bạch, cạnh tranh, có chính sách ưu đãi cho đối tác dài hạn và đoàn lớn.
            </p>
          </div>

          {/* Feature 4 */}
          <div className="bg-gradient-to-br from-purple-50 to-white rounded-2xl p-8 shadow-lg hover:shadow-xl transition-all duration-300 border border-purple-100">
            <div className="w-16 h-16 bg-purple-600 rounded-full flex items-center justify-center mb-6">
              <i className="ri-map-pin-line text-white text-3xl"></i>
            </div>
            <h3 className="text-2xl font-extrabold text-gray-900 mb-4">
              Phủ Sóng Rộng
            </h3>
            <p className="text-lg text-gray-800 leading-relaxed font-semibold">
              Phục vụ toàn bộ miền Tây Hoa Kỳ: California, Nevada, Arizona, Utah và các bang lân cận.
            </p>
          </div>

          {/* Feature 5 */}
          <div className="bg-gradient-to-br from-orange-50 to-white rounded-2xl p-8 shadow-lg hover:shadow-xl transition-all duration-300 border border-orange-100">
            <div className="w-16 h-16 bg-orange-600 rounded-full flex items-center justify-center mb-6">
              <i className="ri-shield-check-line text-white text-3xl"></i>
            </div>
            <h3 className="text-2xl font-extrabold text-gray-900 mb-4">
              An Toàn & Bảo Hiểm
            </h3>
            <p className="text-lg text-gray-800 leading-relaxed font-semibold">
              Xe đạt chuẩn an toàn Mỹ, bảo hiểm đầy đủ, bảo dưỡng định kỳ, đảm bảo hành trình an tâm.
            </p>
          </div>

          {/* Feature 6 */}
          <div className="bg-gradient-to-br from-teal-50 to-white rounded-2xl p-8 shadow-lg hover:shadow-xl transition-all duration-300 border border-teal-100">
            <div className="w-16 h-16 bg-teal-600 rounded-full flex items-center justify-center mb-6">
              <i className="ri-customer-service-2-line text-white text-3xl"></i>
            </div>
            <h3 className="text-2xl font-extrabold text-gray-900 mb-4">
              Hỗ Trợ 24/7
            </h3>
            <p className="text-lg text-gray-800 leading-relaxed font-semibold">
              Đội ngũ hỗ trợ sẵn sàng mọi lúc, giải đáp thắc mắc và xử lý tình huống nhanh chóng.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}
